import { render, staticRenderFns } from "./ModalElevator.vue?vue&type=template&id=408a8546&"
import script from "./ModalElevator.vue?vue&type=script&lang=js&"
export * from "./ModalElevator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports